import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Landing from './Views/Landing';
import Conference from './Views/Conference';
import Speaking from './Views/Speaking';
import Team from './Views/Team';
import Contact from './Views/Contact';
import Others from './Views/Others';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/conference" element={<Conference />} />
            <Route path="/publicspeakingcontest" element={<Speaking />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/others" element={<Others />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;